import { useCallback } from 'react'
import HttpStatus from 'http-status-codes'

import { useGet } from '../apiHooks'
import { setPiiCountryCode } from '../../sweepstakes/messages'
import { config } from '../../components/Init/Init'
import { usePlayerStore } from '../../services/store'
import { useSetPlayerData } from '../../services/store/playerStore/playerActions'

export const useGetAccountDetails = () => {
  const { GET } = useGet()
  const playerStore = usePlayerStore()
  const playerStatus = playerStore.use.status()
  const playerLoginUser = playerStore.use.loginUser()
  const playerCountry = playerStore.use.country()
  const playerSubdivision = playerStore.use.subdivision()

  const { setPlayerData } = useSetPlayerData()

  const getAccountDetails = useCallback(
    ({ successCallback, failCallback }) => {
      if (playerStatus === config.status.partial || playerStatus === config.status.registered) {
        const detailsPath = config.apiUrl + String(config.getAccountDetailsUrl).replace('{id}', playerLoginUser.userId)

        GET(detailsPath, { rawResponse: true })
          .then(response => {
            if (response.status === HttpStatus.OK) {
              return response.json().then(details => {
                if (config.enableSweepstakes) {
                  // any time we grab the details, we want to make sure the coin store currency is updated if needed
                  setPiiCountryCode(details.country)
                }

                if (playerCountry !== details.country || playerSubdivision !== details.subdivision) {
                  // assign the country and subdivision as it's used in a bunch of places and can be wrong in the session where pii is entered
                  setPlayerData({
                    country: details.country,
                    subdivision: details.subdivision
                  })
                }

                successCallback(details)
              })
            } else {
              response.json().then(err => failCallback(err.errorReason))
            }
          })
          .catch(err => {
            failCallback(err)
          })
      } else {
        failCallback('Player is not registered')
      }
    },
    [GET, playerCountry, playerLoginUser.userId, playerStatus, playerSubdivision, setPlayerData]
  )

  return { getAccountDetails }
}
